var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubskill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "skill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.877,
    height: 40.877,
    viewBox: "0 0 40.877 40.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M51.292,9.181a3.8,3.8,0,0,0,3.792-3.792v-1.6a3.792,3.792,0,1,0-7.585,0v1.6A3.8,3.8,0,0,0,51.292,9.181Z",
    transform: "translate(-43.708)",
    fill: "#1a8fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M12.174,119.419a6.178,6.178,0,0,1-9.179,0,7.577,7.577,0,0,0-3,6.034v3.992a2.794,2.794,0,0,0,2.794,2.794h9.581a2.794,2.794,0,0,0,2.794-2.794v-3.992a7.577,7.577,0,0,0-3-6.034Z",
    transform: "translate(0 -109.885)",
    fill: "#1a8fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M45,323.732a2.4,2.4,0,0,0,2.4,2.4h3.194a2.4,2.4,0,0,0,2.4-2.4V310H45Z",
    transform: "translate(-41.407 -285.25)",
    fill: "#1a8fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M343.333,77H331.2a1.2,1.2,0,0,0-1.2,1.2V82.19a1.2,1.2,0,0,0,1.2,1.2h12.135a1.2,1.2,0,0,0,1.2-1.2V78.2A1.2,1.2,0,0,0,343.333,77Z",
    transform: "translate(-303.653 -70.852)",
    fill: "#1a8fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M343.333,217H331.2a1.2,1.2,0,0,0-1.2,1.2v3.992a1.2,1.2,0,0,0,1.2,1.2h12.135a1.2,1.2,0,0,0,1.2-1.2V218.2A1.2,1.2,0,0,0,343.333,217Z",
    transform: "translate(-303.653 -199.675)",
    fill: "#1a8fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M343.333,357H331.2a1.2,1.2,0,0,0-1.2,1.2v3.992a1.2,1.2,0,0,0,1.2,1.2h12.135a1.2,1.2,0,0,0,1.2-1.2V358.2A1.2,1.2,0,0,0,343.333,357Z",
    transform: "translate(-303.653 -328.498)",
    fill: "#1a8fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M216.171,103.2v9.98h-1.6v.24a5.158,5.158,0,0,1-.471,2.156h2.068v9.98a1.2,1.2,0,0,0,1.2,1.2h3.593v-2.4h-2.4v-8.782h2.4v-2.4h-2.4V104.4h2.4V102h-3.593A1.2,1.2,0,0,0,216.171,103.2Z",
    transform: "translate(-197.01 -93.856)",
    fill: "#1a8fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubskill);
export default __webpack_public_path__ + "static/media/subskill.6f6d26dd1275dccd0a0456bab8b2706b.svg";
export { ForwardRef as ReactComponent };